export default "__VITE_ASSET__aa138611__"